<template>
  <transition name="fade" mode="out-in">
    <div class="container py-10">
      <div class="flex flex-wrap -mx-5">
        <div class="md:w-1/3 md:block hidden px-5">
          <img src="/dist/images/logo-seal.jpg" class="max-w-full px-10" alt="AWI Quality Certification Program">
        </div>
        <div>
          <p class="text-3xl mb-3" /></p><h3>Account Details</h3>
          </p>
          <a class="w-1/2" href="/forgotpassword/LoggedInReset">Reset your password</a>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
  export default {
    parent: true,
  };
</script>